<wm-form-activity-input-view 
    [activity]="activity" 
    [form]="form"
    #formActivityInputView
></wm-form-activity-input-view>
